import Mock from 'mockjs'

const MOCK050023 = Mock.mock({
    'respCode': '0000',
    'respMsg': '',
    'respData': {
        'requireNo': '@id',
        'requireBatchNo': '1',
        'requireStatus': '01',
        'requireStatusDisp': '待采购商收货',
        'requireTimeFrom': '@datetime',
        'requireTimeTo': '@datetime',

        'requireList|5-8': [{
            'spuId': '@id',
            'skuId': '@id',
            'skuName': '@cname',
            'attachUrl': '@images(300*300)',
            'model': '@cword(6)',
            'price|500-1000': 500,
            'requireCount|400-1000': 400,
            'totalAmt|1000-2000': 1000
        }]
    }
});

export default MOCK050023


// WEBPACK FOOTER //
// ./src/mock/getRequireOrderDetail.js